import axios from "axios";
import $ from "jquery";
import { getHeaders } from "CommonUtils";
import { postRequest } from "NetworkCall";
import {
  APP_API_KEY,
  INSTANCE_URL,
  LOGIN,
  SELECT_FEATURE,
  GarbageKey,
} from "Constants";
import { STEP_CREATE, STEP_VERIFY, STEP_CHOOSE, STEP_FINISH } from "Signup";
import { SIGNUP_STEP, SIGNUP_FEATURE_SELECT } from "SignupReducer";

export var ACTION_LOGOUT = "ACTION_LOGOUT";
export var SESSION_TOKEN = "SESSION_TOKEN";
export var EVENT = "EVENT";
export var USER_PICTURE = "USER_PICTURE";
export var USER_NAME = "USER_NAME";
export var USER_ID = "USER_ID";
export var ADMIN_USER_ID = "ADMIN_USER_ID";
export var SIGNUP_USER = "SIGNUP_USER";
export var REGISTER_OTP = "REGISTER_OTP";
export var USER_EMAIL = "USER_EMAIL";
export var VERIFY_OTP_LOGIN = "VERIFY_OTP_LOGIN";
export var LOGIN_PROCESS_CALLBACK = "LOGIN_PROCESS_CALLBACK";
export var PREFILLED_LOGIN_CALLBACK = "PREFILLED_LOGIN_CALLBACK";
export var SCRATCH_LOGIN_CALLBACK = "SCRATCH_LOGIN_CALLBACK";
export var ALL_EVENTS = "ALL_EVENTS";
export var ALL_ADMIN_EVENTS = "ALL_ADMIN_EVENTS";
export var OPEN_EVENT_CHOOSER_MODAL = "OPEN_EVENT_CHOOSER_MODAL";
export var INITIATE_CREATE_EVENT = "INITIATE_CREATE_EVENT";
export var IS_SUPERADMIN = "IS_SUPERADMIN";
export var ADMIN_EVENT_LIMITS = "ADMIN_EVENT_LIMITS";
export var ADMIN_EVENT_VALIDUPTO = "ADMIN_EVENT_VALIDUPTO";
export var ADMIN_USERLIMIT = "ADMIN_USERLIMIT";
export var ADMIN_GROUP_NUMBER = "ADMIN_GROUP_NUMBER";
export var ADMIN_CLIENT_NUMBER = "ADMIN_CLIENT_NUMBER";
export var ADMIN_EVENTS_CREATED = "ADMIN_EVENTS_CREATED";
export var OPEN_EVENT_CLONE_MODAL = "OPEN_EVENT_CLONE_MODAL";
export var CLONE_EVENT_STATUS = "CLONE_EVENT_STATUS";
export var DEVICE_SIZE = "DEVICE_SIZE";
export var CLIENTINVOICE_FORPAYMENT = "CLIENTINVOICE_FORPAYMENT";
export var RESET_REDUX_STORE_ADMIN_NO_EVENT =
  "RESET_REDUX_STORE_ADMIN_NO_EVENT";
export var CLIENT_EXPIRYAND_USERLIMIT = "CLIENT_EXPIRYAND_USERLIMIT";

export function mainLogin(values, session, callback) {
  // This function is used on Login screen only
  session["apiKey"] = APP_API_KEY;

  var config = {
    headers: {
      contentType: "application/json; charset=utf-8",
      "X-DreamFactory-Api-Key": APP_API_KEY,
    },
  };

  if (values.password === GarbageKey) {
    var data = {
      email: values.email,
      password: values.password,
      callfrom: "admin",
    };

    var url = `${INSTANCE_URL}/api/v2/eventifyscript/login`;
    var response = axios.post(url, data, config);
    return (dispatch) => {
      response
        .then(({ data }) => {
          // debugger;
          data = data.result;

          // Validate if the user is admin or, not
          dispatch(
            validateUserIfAdmin(
              data,
              {
                ...session,
                session_token: data.session_token,
                email: data.email,
              },
              callback
            )
          );
        })
        .catch((error) => {
          callback({ success: 0, message: error });
        });
    };
  } else {
    var data = {
      email: values.email,
      password: values.password,
      duration: 0,
    };

    var url = `${INSTANCE_URL}/api/v2/user/session`;
    var response = axios.post(url, data, config);
    return (dispatch) => {
      response
        .then(({ data }) => {
          // Validate if the user is admin or, not
          dispatch(
            validateUserIfAdmin(
              data,
              {
                ...session,
                session_token: data.session_token,
                email: data.email,
              },
              callback
            )
          );
        })
        .catch((error) => {
          callback({ success: 0, message: error });
        });
    };
  }
}

export function validateUserIfAdmin(logindata, session, callback) {
  // Check whether logged in user is admin or not
  var sess = { apiKey: session.apiKey, sessionToken: session.session_token };

  var eventUrl = `${INSTANCE_URL}/api/v2/eventifyscript_support?type=user_events&dfid=${logindata.id}`;
  var eventResponse = axios.get(eventUrl, getHeaders(sess));
  return (dispatch) => {
    eventResponse
      .then(({ data }) => {
        let userEventRes = data;
        // console.log("userEventRes admin validate :- ", userEventRes);

        dispatch({ type: ALL_EVENTS, payload: { data: userEventRes } });
        dispatch({ type: ALL_ADMIN_EVENTS, payload: userEventRes.length });
        dispatch({ type: SESSION_TOKEN, payload: { ...session } });
        dispatch({ type: USER_ID, payload: logindata.id });
        dispatch({ type: USER_EMAIL, payload: logindata.email });

        var sess = { apiKey: session.apiKey };
        var filter = encodeURI(
          `(dfid=${logindata.id})AND(email=${logindata.email})`
        );
        var url = `${INSTANCE_URL}/api/v2/eventify/_table/clients?filter=(${filter})&related=event_by_clientidfk&event_by_clientidfk.fields=eventid,eventname`;
        var isSuperAdmin = axios.get(url, getHeaders(sess));
        isSuperAdmin
          .then(({ data }) => {
            let isClientRes = data;
            // console.log("isClientRes :- ", isClientRes);

            if (
              isClientRes.resource.length === 0 &&
              userEventRes.length === 0
            ) {
              callback({ success: 3, message: "Invalid User!" });
            } else if (isClientRes.resource.length > 0) {
              dispatch({ type: IS_SUPERADMIN, payload: true });
              dispatch({
                type: ADMIN_EVENT_LIMITS,
                payload: isClientRes.resource[0].eventslimit,
              });
              dispatch({
                type: ADMIN_EVENT_VALIDUPTO,
                payload: isClientRes.resource[0].validupto,
              });
              dispatch({
                type: ADMIN_USERLIMIT,
                payload: isClientRes.resource[0].userlimit,
              });
              dispatch({
                type: ADMIN_GROUP_NUMBER,
                payload: isClientRes.resource[0].group_number,
              });
              dispatch({
                type: ADMIN_CLIENT_NUMBER,
                payload: isClientRes.resource[0].clientid,
              });
              dispatch({
                type: ADMIN_EVENTS_CREATED,
                payload: isClientRes.resource[0].event_by_clientidfk.length,
              });

              dispatch(
                checkAdminEvents(
                  session,
                  callback,
                  userEventRes,
                  isClientRes.resource[0].clientid
                )
              );
            } else {
              dispatch(checkAdminEvents(session, callback, userEventRes));
            }
          })
          .catch((error) => {
            if (userEventRes.length > 0) {
              checkAdminEvents(session, callback, userEventRes);
            } else {
              callback({ success: 3, message: "Invalid User!" });
            }
          });
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function checkAdminEvents(
  session,
  callback,
  userEventRes,
  clientid = ""
) {
  // Check if event has only one event
  if (userEventRes.length === 1) {
    // var sess = { apiKey: session.apiKey };
    var sess = { apiKey: session.apiKey, sessionToken: session.session_token };

    return (dispatch) => {
      dispatch(
        checkClientExpiryDate(userEventRes[0].eventid, sess, (res) => {
          // console.log("res :- ", res);

          if (res.success == 1) {
            var eventdata = userEventRes[0];

            dispatch({
              type: SESSION_TOKEN,
              payload: {
                apiKey: session.apiKey,
                email: session.email,
                session_token: eventdata.session_token,
              },
            });

            dispatch({
              type: EVENT,
              payload: {
                eventid: eventdata.eventid,
                eventname: eventdata.eventname,
                onesignalid: eventdata.onesignalid,
                onesignalkey: eventdata.onesignalkey,
                userid: eventdata.appuserid,
                userpic: eventdata.profileurl,
              },
            });
            dispatch(markLogin());
            setTimeout(() => {
              callback({ success: 1, session });
            }, 1000);
          } else {
            callback({ success: 101 });
          }
        })
      );
    };
  } else {
    callback({
      success: 4,
      session,
      ...(clientid === "" ? {} : { clientid: clientid }),
    }); // Open Event Chooser
  }
}

export function validateUserIfAdmin_old(logindata, session, callback) {
  // Check whether logged in user is admin or not
  var sess = { apiKey: session.apiKey, sessionToken: session.session_token };
  // console.log("logindata :- ", logindata);
  // console.log("session :- ", session);

  var filter = encodeURI(`(dfid=${logindata.id})AND(isadmin=1)`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?filter=(${filter})&caller=web&include_token=true`;
  var response = axios.get(url, getHeaders(sess));
  return (dispatch) => {
    response
      .then(({ data }) => {
        // if (data.resource.length == 1) {
        //   dispatch(
        //     checkClientExpiryDate(data.resource[0].eventid, sess, (res) => {
        //       if (res.success == 1) {
        //         var appUser = data.resource[0];
        //         dispatch(
        //           fetchEventData(
        //             appUser,
        //             {
        //               apiKey: session.apiKey,
        //               email: session.email,
        //               session_token: appUser.session_token,
        //             },
        //             (evres) => {
        //               if (evres.success == 1) {
        //                 var event = evres.data;

        //                 dispatch({
        //                   type: SESSION_TOKEN,
        //                   payload: {
        //                     apiKey: session.apiKey,
        //                     email: session.email,
        //                     session_token: appUser.session_token,
        //                   },
        //                 });
        //                 dispatch({ type: USER_ID, payload: logindata.id });
        //                 dispatch({
        //                   type: USER_PICTURE,
        //                   payload: appUser.profileurl,
        //                 });
        //                 dispatch({
        //                   type: USER_EMAIL,
        //                   payload: logindata.email,
        //                 });
        //                 dispatch({
        //                   type: ADMIN_USER_ID,
        //                   payload: appUser.appuserid,
        //                 });
        //                 dispatch({
        //                   type: EVENT,
        //                   payload: {
        //                     eventid: event.eventid,
        //                     eventname: event.eventname,
        //                     onesignalid: event.onesignalid,
        //                     onesignalkey: event.onesignalkey,
        //                     userid: appUser.appuserid,
        //                   },
        //                 });
        //                 dispatch(
        //                   checkuserSuperAdmin(logindata, session, callback)
        //                 );
        //                 dispatch(markLogin());
        //                 setTimeout(() => {
        //                   callback({ success: 1, session });
        //                 }, 1000);
        //               } else {
        //                 callback({ success: 102 });
        //               }
        //             }
        //           )
        //         );
        //       } else {
        //         callback({ success: 101 });
        //       }
        //     })
        //   );
        // } else
        if (data.resource.length > 0) {
          dispatch({ type: SESSION_TOKEN, payload: { ...session } });
          dispatch({ type: USER_ID, payload: logindata.id });
          dispatch({ type: USER_EMAIL, payload: logindata.email });
          dispatch(checkuserSuperAdmin(logindata, session, callback));

          var eventUrl = `${INSTANCE_URL}/api/v2/eventifyscript_support?type=user_events&dfid=${logindata.id}`;
          var eventResponse = axios.get(eventUrl, getHeaders(sess));
          eventResponse
            .then(({ data }) => {
              dispatch({ type: ALL_EVENTS, payload: { data: data } });
              dispatch({ type: ALL_ADMIN_EVENTS, payload: data.length });
              callback({ success: 4, session }); //Open Event Chooser
            })
            .catch((error) => {
              callback({ success: 0, message: error });
            });
        } else {
          callback({ success: 3, message: "Invalid User!" });
        }
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function checkuserSuperAdmin(user, session, callback) {
  // Check whether logged in user is superadmin or not

  var sess = { apiKey: session.apiKey };

  var filter = encodeURI(`(dfid=${user.id})AND(email=${user.email})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/clients?related=event_by_clientidfk&event_by_clientidfk.fields=eventid,eventname&filter=${filter}`;
  var isSuperAdmin = axios.get(url, getHeaders(sess));
  return (dispatch) => {
    isSuperAdmin
      .then(({ data }) => {
        if (data.resource.length > 0) {
          dispatch({ type: IS_SUPERADMIN, payload: true });
          dispatch({
            type: ADMIN_EVENT_LIMITS,
            payload: data.resource[0].eventslimit,
          });
          dispatch({
            type: ADMIN_EVENT_VALIDUPTO,
            payload: data.resource[0].validupto,
          });
          dispatch({
            type: ADMIN_USERLIMIT,
            payload: data.resource[0].userlimit,
          });
          dispatch({
            type: ADMIN_GROUP_NUMBER,
            payload: data.resource[0].group_number,
          });
          dispatch({
            type: ADMIN_CLIENT_NUMBER,
            payload: data.resource[0].clientid,
          });
          dispatch({
            type: ADMIN_EVENTS_CREATED,
            payload: data.resource[0].event_by_clientidfk.length,
          });
        }
      })
      .catch((error) => {
        // callback({ success: 0, message: error });
        callback({ success: 1, session });
      });
  };
}

export function fetchEventData(user, session, callback) {
  var filter1 = encodeURI(`eventid=${user.eventid}`);
  var url1 = `${INSTANCE_URL}/api/v2/eventify/_table/event?filter=(${filter1})`;
  var response = axios.get(url1, getHeaders(session));

  return (dispatch) => {
    response
      .then(({ data }) => {
        var event = data.resource[0];

        callback({ success: 1, data: event });
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function loginToApp(values, session, callback) {
  //This function is used at other places like password change where Login is required...
  var config = {
    headers: {
      contentType: "application/json; charset=utf-8",
      "X-DreamFactory-Api-Key": APP_API_KEY,
    },
  };

  var data = {
    email: values.email,
    password: values.password,
    duration: 0,
  };

  var url = `${INSTANCE_URL}/api/v2/user/session`;
  var response = axios.post(url, data, config);

  return (dispatch) => {
    response
      .then(({ data }) => {
        dispatch(
          updateSessionToken(
            session,
            { appuserid: values.appuserid },
            (sessionres) => {
              if (sessionres.success) {
                dispatch({
                  type: SESSION_TOKEN,
                  payload: { ...sessionres.data },
                });
                callback({ success: 1 });
              } else {
                callback({ success: 0 });
              }
            }
          )
        );
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function clearAdminEvents() {
  return { type: ALL_EVENTS, payload: {} };
}

export function verifyOtpLogin(option = true) {
  return { type: VERIFY_OTP_LOGIN, payload: option };
}

export function loginProcessCallback(callback) {
  return { type: LOGIN_PROCESS_CALLBACK, payload: callback };
}

export function preFilledLoginCallback(callback) {
  return { type: PREFILLED_LOGIN_CALLBACK, payload: callback };
}

export function scratchLoginCallback(callback) {
  return { type: SCRATCH_LOGIN_CALLBACK, payload: callback };
}

export function openEventChooser({ showModal }) {
  return { type: OPEN_EVENT_CHOOSER_MODAL, payload: showModal };
}

export function fetchEventDetails_notInUse(user, session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?filter=%28dfid=${user.userid}%29AND%28isadmin=1%29`;
  var response = axios.get(url, getHeaders(session));

  return (dispatch) => {
    response
      .then(({ data }) => {
        //If there is only one associated event directly login
        if (data.resource.length == 1) {
          var adminUserId = data.resource[0].appuserid;
          var eventid = data.resource[0].eventid;

          dispatch({ type: ADMIN_USER_ID, payload: adminUserId });

          var eventUrl = `${INSTANCE_URL}/api/v2/eventify/_table/event?filter=eventid=${eventid}`;
          var eventResponse = axios.get(eventUrl, getHeaders(session));

          eventResponse
            .then(({ data }) => {
              var event = data.resource[0];
              dispatch({
                type: EVENT,
                payload: {
                  eventid: event.eventid,
                  eventname: event.eventname,
                  onesignalid: event.onesignalid,
                  onesignalkey: event.onesignalkey,
                  userid: adminUserId,
                },
              });
              dispatch(markLogin());
              callback({ success: 1, session });
            })
            .catch((error) => {
              callback({ success: 0, message: error });
            });
        } else {
          var eventUrl = `${INSTANCE_URL}/api/v2/eventifyscript_support?type=user_events&dfid=${user.userid}`;
          var eventResponse = axios.get(eventUrl, getHeaders(session));
          eventResponse
            .then(({ data }) => {
              dispatch({ type: ALL_EVENTS, payload: { data: data } });
              dispatch({ type: ALL_ADMIN_EVENTS, payload: data.length });
              callback({ success: 4, session }); //Open Event Chooser
            })
            .catch((error) => {
              callback({ success: 0, message: error });
            });
        }
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

// Call from different components with (user and session props)
export function getClientEventStatus(user, session, callback) {
  // Check latest admin stayus
  var sess = { apiKey: session.apiKey, sessionToken: session.sessionToken };

  var eventUrl = `${INSTANCE_URL}/api/v2/eventifyscript_support?type=user_events&dfid=${user.userid}`;
  var eventResponse = axios.get(eventUrl, getHeaders(sess));
  return (dispatch) => {
    eventResponse
      .then(({ data }) => {
        let userEventRes = data;
        // console.log("userEventRes get latest client :- ", userEventRes);

        dispatch({ type: ALL_EVENTS, payload: { data: userEventRes } });
        dispatch({ type: ALL_ADMIN_EVENTS, payload: userEventRes.length });

        var sess = { apiKey: session.apiKey };
        var filter = encodeURI(`(dfid=${user.userid})AND(email=${user.email})`);
        var url = `${INSTANCE_URL}/api/v2/eventify/_table/clients?filter=(${filter})&related=event_by_clientidfk&event_by_clientidfk.fields=eventid,eventname`;
        var isSuperAdmin = axios.get(url, getHeaders(sess));
        isSuperAdmin
          .then(({ data }) => {
            let isClientRes = data;
            // console.log("isClientRes :- ", isClientRes);

            if (isClientRes.resource.length > 0) {
              dispatch({ type: IS_SUPERADMIN, payload: true });
              dispatch({
                type: ADMIN_EVENT_LIMITS,
                payload: isClientRes.resource[0].eventslimit,
              });
              dispatch({
                type: ADMIN_EVENT_VALIDUPTO,
                payload: isClientRes.resource[0].validupto,
              });
              dispatch({
                type: ADMIN_USERLIMIT,
                payload: isClientRes.resource[0].userlimit,
              });
              dispatch({
                type: ADMIN_GROUP_NUMBER,
                payload: isClientRes.resource[0].group_number,
              });
              dispatch({
                type: ADMIN_CLIENT_NUMBER,
                payload: isClientRes.resource[0].clientid,
              });
              dispatch({
                type: ADMIN_EVENTS_CREATED,
                payload: isClientRes.resource[0].event_by_clientidfk.length,
              });

              callback({
                success: 1,
                adminevents: userEventRes,
                clientdata: isClientRes,
              });
            }
          })
          .catch((error) => {
            callback({ success: 1, adminevents: userEventRes });
          });
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function fetchAllRelatedEvents(user, session, callback) {
  var eventUrl = `${INSTANCE_URL}/api/v2/eventifyscript_support?type=user_events&dfid=${user.userid}`;
  var eventResponse = axios.get(eventUrl, getHeaders(session));
  return (dispatch) => {
    eventResponse
      .then(({ data }) => {
        let userEventRes = data;
        // console.log("userEventRes refresh :- ", userEventRes);

        dispatch({ type: ALL_EVENTS, payload: { data: userEventRes } });
        dispatch({ type: ALL_ADMIN_EVENTS, payload: userEventRes.length });
        callback({ successs: 1, data: userEventRes });
      })
      .catch((error) => {});
  };
}

export function fetchEventDetailsForGuest(user, session, callback) {
  //This function is used for Preview Login for Guests
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?filter=%28dfid=${user.userid}%29AND%28isadmin=1%29`;
  var response = axios.get(url, getHeaders(session));

  return (dispatch) => {
    response
      .then(({ data }) => {
        //If there is only one associated event directly login
        var adminUserId = data.resource[0].appuserid;
        var eventid = data.resource[0].eventid;

        dispatch({ type: ADMIN_USER_ID, payload: adminUserId });

        var eventUrl = `${INSTANCE_URL}/api/v2/eventify/_table/event?filter=eventid=${eventid}`;
        var eventResponse = axios.get(eventUrl, getHeaders(session));

        eventResponse
          .then(({ data }) => {
            var event = data.resource[0];
            dispatch({
              type: EVENT,
              payload: {
                eventid: event.eventid,
                eventname: event.eventname,
                onesignalid: event.onesignalid,
                onesignalkey: event.onesignalkey,
                userid: adminUserId,
              },
            });
            dispatch(markLogin());
            callback({ success: 1, session });
          })
          .catch((error) => {
            callback({ success: 0, message: error });
          });
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function loginToEvent(eventdata) {
  return (dispatch) => {
    dispatch({
      type: EVENT,
      payload: {
        eventid: eventdata.eventid,
        eventname: eventdata.eventname,
        onesignalid: eventdata.onesignalid,
        onesignalkey: eventdata.onesignalkey,
        userid: eventdata.appuserid,
        userpic: eventdata.profileurl,
      },
    });
  };
}

export function initiateCreateEvent({ initiate }) {
  return { type: INITIATE_CREATE_EVENT, payload: initiate };
}

export function preRegisterUser(values, callback) {
  var config = {
    headers: {
      contentType: "application/json; charset=utf-8",
      "X-DreamFactory-Api-Key": APP_API_KEY,
    },
  };

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/tempuser`;
  var request = {
    resource: [
      {
        email: values.email,
      },
    ],
  };

  var response = axios.post(url, request, config);

  return (dispatch) => {
    response
      .then(({ data }) => {
        var user = {
          tempuserid: data.resource[0].tempuserid,
          email: values.email,
          password: values.password,
        };
        dispatch({ type: SIGNUP_USER, payload: user });
        dispatch({ type: SIGNUP_STEP, payload: STEP_VERIFY });
        callback({ success: 1 });
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function verifyCodeAndRegister(otp, user, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/tempuser/${user.tempuserid}`;
  var config = {
    headers: {
      contentType: "application/json; charset=utf-8",
      "X-DreamFactory-Api-Key": APP_API_KEY,
    },
  };

  var response = axios.get(url, config);

  return (dispatch) => {
    response
      .then(({ data }) => {
        if (data.otp === otp) {
          dispatch(registerToApp(user, callback));
        } else {
          callback({ success: 0, message: "OTP is not verified" });
        }
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function onChangeEmail() {
  return {
    type: SIGNUP_STEP,
    payload: STEP_CREATE,
  };
}

export function registerToApp(values, callback) {
  var config = {
    headers: {
      contentType: "application/json; charset=utf-8",
      "X-DreamFactory-Api-Key": APP_API_KEY,
    },
  };

  var data = {
    email: values.email,
    new_password: values.password,
  };

  var url = `${INSTANCE_URL}/api/v2/user/register?login=true`;
  var response = axios.post(url, data, config);

  return (dispatch) => {
    response
      .then(({ data }) => {
        var adminUserId = data.adminuser.content.resource[0].userid;
        dispatch({ type: USER_ID, payload: adminUserId });
        dispatch({
          type: SESSION_TOKEN,
          payload: { ...data.session_token, apiKey: APP_API_KEY },
        });
        dispatch(markLogin());
        dispatch({ type: SIGNUP_STEP, payload: STEP_CHOOSE });
        callback({ success: 1 });
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function selectFeatures(features) {
  return {
    type: SELECT_FEATURE,
    payload: { features: features },
  };
}

export function selectSingupFeature(feature) {
  return {
    type: SIGNUP_FEATURE_SELECT,
    payload: feature,
  };
}

function parseErrorResponse(response) {
  var responseObj = JSON.parse(response);

  if (responseObj.hasOwnProperty("error")) {
    if (responseObj.error.context !== null) {
      var errMsg = "";

      $.each(responseObj.error.context, function (data) {
        errMsg +=
          "<br> - " +
          responseObj.error.context[data][0].replace(/&quot;/g, '"');
      });

      var message = responseObj.error.message + "<br>" + errMsg;
      return {
        code: responseObj.error.code,
        message: message,
        error: JSON.stringify(response),
      };
    } else {
      return {
        code: responseObj.error.code,
        message: responseObj.error.message.replace(/&quot;/g, '"'),
        error: JSON.stringify(response),
      };
    }
  } else {
    return false;
  }
}

export function markLogin() {
  return (dispatch) => {
    dispatch({ type: LOGIN, payload: true });
  };
}

export function resetSession() {
  return (dispatch) => {
    dispatch({ type: "RESET" });
    dispatch({ type: SESSION_TOKEN, payload: {} });
  };
}

export function logout(session) {
  var url = `${INSTANCE_URL}/api/v2/user/session`;
  var response = axios.delete(url, getHeaders(session));
  return (dispatch) => {
    response
      .then(({ data }) => {
        dispatch({ type: ACTION_LOGOUT, payload: false });
        dispatch({ type: "RESET" });
      })
      .catch((error) => {
        // nothing to do
        dispatch({ type: ACTION_LOGOUT, payload: false });
      });
  };
}

export function createEventInsideDashboard(show) {
  return (dispatch) => {
    dispatch({ type: "CREATE_EVENT_INSIDE_DASHBORAD", payload: show });
  };
}

export function openCloneOptions({ showModal }) {
  return { type: OPEN_EVENT_CLONE_MODAL, payload: showModal };
}

export function cloneEventAction(session, options, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  var eventid = parseInt(session.eventid, 10);
  var postData = {
    eventid: eventid,
    eventname: session.eventname,
    options: options,
    type: "clone_event_new",
  };
  // var postData = { type: 'clone_event_new' };

  return (dispatch) => {
    postRequest(
      url,
      postData,
      session,
      dispatch,
      (data) => {
        callback({ success: 1, result: data });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function getDeviceSize() {
  // GETTING DYNAMIC HEIGHT AND WIDTH
  let screen = window.screen;
  var isMobile = window.innerWidth > 0 ? false : true;
  let width = 1440;
  let height = 815;

  if (isMobile === false) {
    width = window.innerWidth;
    height = window.innerHeight;
  } else {
    width = screen.width;
    height = screen.height;
  }
  let size = { width: width, height: height };

  return { type: DEVICE_SIZE, payload: size };
}

export function checkSubdomain(subdomain, session, callback) {
  var config = {
    headers: {
      contentType: "application/json; charset=utf-8",
      "X-DreamFactory-Api-Key": APP_API_KEY,
    },
  };

  var filter = encodeURI(`(seocode=${subdomain})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event?filter=${filter}`;
  var response = axios.get(url, config);

  return (dispatch) => {
    response
      .then(({ data }) => {
        if (data.resource.length > 0) {
          var returnData = { success: 2 };
          callback(returnData);
        } else {
          var returnData = { success: 1 };
          callback(returnData);
        }
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function validateClientEmail(values, session, callback) {
  var config = {
    headers: {
      contentType: "application/json; charset=utf-8",
      "X-DreamFactory-Api-Key": APP_API_KEY,
    },
  };

  var filter = encodeURI(`(email=${values.email})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/clients?filter=${filter}`;
  var response = axios.get(url, config);

  return (dispatch) => {
    response
      .then(({ data }) => {
        var returnData = { success: 1, data: data.resource };
        callback(returnData);
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function mainSigup(values, session, callback) {
  var config = {
    headers: {
      contentType: "application/json; charset=utf-8",
      "X-DreamFactory-Api-Key": APP_API_KEY,
    },
  };

  var data = { ...values };
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/signupClient`;
  var response = axios.post(url, data, config);
  return (dispatch) => {
    response
      .then(({ data }) => {
        if (data.success == 1) {
          session = {
            ...session,
            apiKey: APP_API_KEY,
            email: data.clientresponse.email,
            session_token: data.clientresponse.session_token,
          };

          dispatch({ type: SESSION_TOKEN, payload: { ...session } });
          dispatch({ type: USER_ID, payload: data.clientresponse.userid });
          dispatch({ type: USER_EMAIL, payload: data.clientresponse.email });
          dispatch({ type: IS_SUPERADMIN, payload: true });
          dispatch({
            type: ADMIN_EVENT_LIMITS,
            payload: data.clientresponse.eventslimit,
          });
          dispatch({
            type: ADMIN_EVENT_VALIDUPTO,
            payload: data.clientresponse.validupto,
          });
          dispatch({
            type: ADMIN_USERLIMIT,
            payload: data.clientresponse.userlimit,
          });
          dispatch({
            type: ADMIN_GROUP_NUMBER,
            payload: data.clientresponse.group_number,
          });
          dispatch({
            type: ADMIN_CLIENT_NUMBER,
            payload: data.clientresponse.clientid,
          });
          dispatch({
            type: ADMIN_EVENTS_CREATED,
            payload: 1,
          });
          setTimeout(() => {
            callback({
              success: 1,
              data: data.clientresponse,
              session: session,
            });
          }, 1000);
        } else {
          callback({ success: 2 });
        }
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function checkClientExpiryDate(eventid, session, callback) {
  var body = { eventid: eventid };
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/checkClientExpired`;
  var response = axios.post(url, body, getHeaders(session));

  return (dispatch) => {
    response
      .then(({ data }) => {
        if (data.success == 1) {
          callback({ success: 1, data: data });
        } else {
          callback({ success: 0 });
        }
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function checkClientuserlimitandexpiry(clientid, session, callback) {
  var body = { clientid: clientid };
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/checkClientuserlimitandexpiry`;
  var response = axios.post(url, body, getHeaders(session));

  return (dispatch) => {
    response
      .then(({ data }) => {
        if (data.success == 1) {
          dispatch({
            type: CLIENT_EXPIRYAND_USERLIMIT,
            payload: data,
          });
          callback({ success: 1, data: data });
        } else {
          callback({ success: 0 });
        }
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function refreshSessionToken(session, values, callback) {
  return (dispatch) => {
    dispatch(
      updateSessionToken(
        session,
        { appuserid: values.appuserid },
        (sessionres) => {
          dispatch({
            type: SESSION_TOKEN,
            payload: { ...sessionres.data },
          });
          callback({ success: 1 });
        }
      )
    );
  };
}

export function updateSessionToken(session, values, callback) {
  var filter = encodeURI(`(appuserid=${values.appuserid})AND(isadmin=1)`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?filter=(${filter})&caller=web&include_token=true`;
  var response = axios.get(url, getHeaders(session));

  return (dispatch) => {
    response
      .then(({ data }) => {
        if (data.resource.length > 0) {
          callback({ success: 1, data: data.resource[0] });
        } else {
          callback({ success: 0 });
        }
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function initiateReset(values, callback) {
  //This function is used To initiate Reset
  var config = {
    headers: {
      contentType: "application/json; charset=utf-8",
      "X-DreamFactory-Api-Key": APP_API_KEY,
    },
  };

  var data = {
    email: values.email,
  };

  var url = `${INSTANCE_URL}/api/v2/user/password?reset=true`;
  var response = axios.post(url, data, config);
  return (dispatch) => {
    response
      .then(({ data }) => {
        callback({ success: 1, message: "Success" });
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function processReset(values, callback) {
  //This function is used To initiate Reset
  var config = {
    headers: {
      contentType: "application/json; charset=utf-8",
      "X-DreamFactory-Api-Key": APP_API_KEY,
    },
  };

  var data = {
    email: values.email,
    code: values.passcode,
    new_password: values.password,
  };

  var url = `${INSTANCE_URL}/api/v2/user/password`;
  var response = axios.post(url, data, config);
  return (dispatch) => {
    response
      .then(({ data }) => {
        callback({ success: 1, message: "Success" });
      })
      .catch((error) => {
        callback({ success: 0, message: error.response.data.error.message });
      });
  };
}

export function deleteEvent(session, eventid, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/eventdelete`;
  var postData = {
    eventid: eventid,
  };

  return (dispatch) => {
    postRequest(
      url,
      postData,
      session,
      dispatch,
      (data) => {
        // console.log("data :- ", data);
        if (data.success) {
          callback({ success: 1, result: data });
        } else {
          callback({ success: 0, result: data });
        }
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function resetStoreForAdminEvents() {
  return (dispatch) => {
    dispatch({ type: RESET_REDUX_STORE_ADMIN_NO_EVENT });
  };
}

// Billing api calls
export function fetchclientInvoiceinfo(session, invoiceid, callback) {
  //This function is used To initiate Reset
  var config = {
    headers: {
      contentType: "application/json; charset=utf-8",
      "X-DreamFactory-Api-Key": APP_API_KEY,
    },
  };

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/clientinvoice?fields=*&related=*&filter=id=${invoiceid}`;
  var response = axios.get(url, config);
  return (dispatch) => {
    response
      .then(({ data }) => {
        dispatch({
          type: CLIENTINVOICE_FORPAYMENT,
          payload: { data: data.resource },
        });
        callback({ success: 1, message: "Success", data: data.resource });
      })
      .catch((error) => {
        callback({ success: 0, message: error.response.data.error.message });
      });
  };
}
